import React, { useCallback, useMemo } from 'react';
import classNames                      from 'classnames';

const CompareParameter = function(props) {
  const {
          compareBest,
          getParameterItem,
          parameters,
          showInfo,
          screenWidth,
          title,
        } = props;

  const isNotEmptyParameter = useMemo(() => {
    return parameters.some((parameter) => getParameterItem(parameter)?.value);
  }, [getParameterItem, parameters]);

  // Best value of the row (parameter setting compareBest: 'max' / 'min'): cells are ranked by their number
  // when every filled cell has one, otherwise by the catalog value position; highlighted only when the
  // compared offers differ.
  const bestRank = useMemo(() => {
    if (!compareBest || parameters.length < 2) {
      return null;
    }

    const cells   = parameters.map((parameter) => getParameterItem(parameter)).filter((cell) => cell?.value);
    const rankKey = cells.every((cell) => typeof cell.number === 'number')
      ? 'number'
      : cells.every((cell) => typeof cell.position === 'number') ? 'position' : null;

    if (!rankKey || cells.length < 2) {
      return null;
    }

    const ranks = new Set(cells.map((cell) => cell[rankKey]));
    if (ranks.size < 2) {
      return null;
    }

    return {
      key:   rankKey,
      value: compareBest === 'min' ? Math.min(...ranks) : Math.max(...ranks),
    };
  }, [compareBest, parameters, getParameterItem]);

  const renderValueWithTooltip = useCallback((cell) => {
    const { value, description } = cell;
    const displayValue  = value || '-';
    const isHighlighted = !!bestRank && !!value && cell[bestRank.key] === bestRank.value;

    if (typeof description !== 'string' || description.trim() === '') {
      return (
        <div className={'value_wrapper'}>
          <p className={classNames('value', { highlight: isHighlighted })}>{displayValue}</p>
        </div>
      );
    }

    return (
      <div className={'value_wrapper'}>
        <p className={classNames('value', { highlight: isHighlighted })}>
          {displayValue}
          <i
            className={'ic-question'}
            onClick={() => showInfo(value, description)}
          />
        </p>
      </div>
    );
  }, [bestRank, showInfo]);

  if (!isNotEmptyParameter) {
    return null;
  }

  return (
    <>
      {screenWidth < 767 && (
        <tr className={'mobile_title'}>
          <td>{title}</td>
        </tr>
      )}
      <tr>
        {screenWidth > 767 && <td className={'title'}>{title}</td>}
        {parameters.map((parameter, index) => {
          const parameterItem = getParameterItem(parameter);

          if (!parameterItem) {
            return (
              <td key={index}>
                <p className={'value'}>-</p>
              </td>
            );
          }

          return (
            <td key={index}>{renderValueWithTooltip(parameterItem)}</td>
          );
        })}
        <td />
      </tr>
    </>
  );
};

export default CompareParameter;